import React from 'react';
import styled from 'styled-components';

import type { LoadingLayoutProps } from '@typings/layout.ts';

import findByLayoutId from '../../utils/findByLayoutId.ts';

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: auto 542px;
  @media (min-width: 2000px) {
    grid-template-columns: auto 1084px;
  }
  grid-template-areas: 'content map';
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 10;
  overflow: hidden;
`;

const Map = styled.div`
  grid-area: map;
  height: 100%;
  position: relative;
`;

const Content = styled.div`
  grid-area: content;
  height: 100%;
  overflow: hidden;
`;

export default function ModEditorLayout({ app, children, Loading, mapLoaded }: LoadingLayoutProps) {
  const content = findByLayoutId('content', children, app);
  const map = findByLayoutId('map', children, app);
  const appInfo = findByLayoutId('appInfo', children, app);

  return (
    <Loading hasLoaded={mapLoaded}>
      <Wrapper>
        <Map>
          {map}
          {appInfo}
        </Map>
        {mapLoaded && <Content>{content}</Content>}
      </Wrapper>
    </Loading>
  );
}
